import CardsView from './view';

/**
 * /components/cards — a live showcase of reusable card patterns, each
 * rebuilt entirely from our fragments + design tokens (Card shell + Text,
 * Button, StatusChip, ButtonGroup, MetricCard, Menu…). Companion to the
 * `card-kit` skill. Pure presentational route — no data fetching, mock data
 * lives inside each example card.
 */
export default function CardExamples() {
    return <CardsView />;
}
